import Vue from 'vue'

const state = {
}

const getters = {
    status2variant(state) {
        return (status) => {
            const table = {
                'saved': 'dark',
                'paid': 'dark',
                'shipped': 'success',
                'canceled': 'success',
                //'listed': 'info',
                //'sold': 'danger',
                //'': 'warning',
            }
            return table[status]
        }
    },
}

const mutations = {
}

const actions = {
    async save (context, data) {
        const formData = new FormData()
//        formData.append('file', this.file)
        data.items.forEach((item, index) => {
            formData.append(`items[${index}][file]`, item.file)
            item.pecs.forEach((detail, index2) => {
console.log(detail, index2)
                formData.append(`items[${index}][pecs][${index2}][pec]`, detail.pec || '')
                formData.append(`items[${index}][pecs][${index2}][quantity]`, detail.quantity || '')
            })
        })

        return axios.post('/api/v1/shipping_crobo' + (data.id ? '/' + data.id : ''), formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        })
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })

    },
//    async order_search (context, data) {
//        const response = await axios.get('/api/v1/shipping_crobo', {
//            params: (typeof data === 'object' ? data : null)
//        })
//        .catch(error => error.response || null)
//        return response
//    },
    async index (context, data) {
        const response = await axios.get('/api/v1/shipping_crobo', {
            params: (typeof data === 'object' ? data : null)
        })
        .catch(error => error.response || null)
        return response
    },
    async download (context, data) {
        data = Object.assign(data, { download: true, })
        const response = await axios.get('/api/v1/shipping_ecms_order', {
            params: (typeof data === 'object' ? data : null),
            responseType: 'blob',
            dataType: 'binary',
            headers: { 'Cache-Control': 'no-cache' },
        })
        .catch(error => error.response || null)
        Vue.prototype.download(response)
        return response
    },

    async action (context, data) {
        return axios.post('/api/v1/shipping_crobo/' + data.order_id  + '/' + data.action, {
                order_no: data.order_no,
            })
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })

    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

